import { apiRequest, DataReturnType, HttpMethods } from "@alba-cars/common-modules";

interface UpdateBankValuationInspectionPerfectPayload {
  requiresInspection: boolean;
  status: "booked";
  inspectionType: "alba" | "home";
  inspectionDate: string;
  scheduledAtUtc: string;
  addressText: string;
  googleMapsPinUrl: string;
  timezone: string;
  timeSlotCode: string;
}

export const updateBankValuationInspectionPerfect = async (
  valuationId: string,
  payload: UpdateBankValuationInspectionPerfectPayload,
) => {
  return apiRequest<DataReturnType<unknown>>(`/bank-valuation-request/${valuationId}/inspection/perfect`, {
    method: HttpMethods.PUT,
    body: JSON.stringify(payload),
  });
};
